import { AppContext } from './AppContext';
import { useContext } from 'react';

export const useAddClosingFunction = () => {
  const { addClosingFunction } = useContext(AppContext);

  return { addClosingFunction: addClosingFunction };
};
